export const rightSlideOutWidth = (size: "xs" | "sm" | "md" | "lg" | "xl" | "initial") => {
	switch (size) {
		case "xl":
			return "500px"
		case "lg":
			return "400px"
		case "md":
			return "50%"
		case "sm":
			return "50%"
		case "xs":
			return "90%"
		case "initial":
			return "90%"
		default:
			return "0"
	}
}

export const aiSlideOutWidth = (size: "xs" | "sm" | "md" | "lg" | "xl" | "initial") => {
	switch (size) {
		case "xl":
			return "500px"
		case "lg":
			return "350px"
		case "md":
			return "50%"
		case "sm":
			return "50%"
		case "xs":
			return "100%"
		case "initial":
			return "100%"
		default:
			return "0"
	}
}

export const defaultOpen = { small: false, large: true }

export enum SLIDE_OUT_IDS {
	LEFT = "left_slide_out",
	RIGHT = "right_slide_out",
	AI = "ai_slide_out",
}
